import { render, staticRenderFns } from "./JobSeekersAppraisal.vue?vue&type=template&id=b49da37c&scoped=true&"
import script from "./JobSeekersAppraisal.vue?vue&type=script&lang=js&"
export * from "./JobSeekersAppraisal.vue?vue&type=script&lang=js&"
import style0 from "./JobSeekersAppraisal.vue?vue&type=style&index=0&id=b49da37c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49da37c",
  null
  
)

export default component.exports